import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=6c9654d4&scoped=true&lang=pug"
import script from "./Quiz.vue?vue&type=script&lang=ts"
export * from "./Quiz.vue?vue&type=script&lang=ts"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=6c9654d4&prod&lang=scss&scoped=true"
import style1 from "./Quiz.vue?vue&type=style&index=1&id=6c9654d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9654d4",
  null
  
)

export default component.exports